import { useState } from "react";
import shelvesBulk from "@/assets/store-shelves-bulk-products.jpg";
import shelvesFlour from "@/assets/store-shelves-flour.jpg";
import flourBags from "@/assets/store-flour-bags.jpg";
import deliveryTruck from "@/assets/store-delivery-truck.jpg";
import petFoodVincent from "@/assets/store-pet-food-vincent.jpg";
import dogFoodLibra from "@/assets/store-dog-food-libra.jpg";
import dogTreats from "@/assets/store-dog-treats.jpg";
import freshProduce from "@/assets/store-fresh-produce.jpg";
import petAccessories from "@/assets/store-pet-accessories.jpg";
import petCareProducts from "@/assets/store-pet-care-products.jpg";
import woodenShelves from "@/assets/store-wooden-shelves.jpg";
import gardenSeeds from "@/assets/store-garden-seeds.jpg";

const Gallery = () => {
  const [visibleCount, setVisibleCount] = useState(3);
  const images = [
    { src: gardenSeeds, alt: "Semi Franchi per orto e giardino" },
    { src: woodenShelves, alt: "Scaffali in legno con prodotti vari" },
    { src: petCareProducts, alt: "Prodotti per l'igiene degli animali" },
    { src: shelvesBulk, alt: "Scaffali con prodotti sfusi" },
    { src: shelvesFlour, alt: "Scaffali con farine di qualità" },
    { src: flourBags, alt: "Sacchi di farine Molini Fagioli" },
    { src: deliveryTruck, alt: "Carico furgone - Pietro e Napoleone al lavoro" },
    { src: petFoodVincent, alt: "Cibo per animali Vincent Diet" },
    { src: dogFoodLibra, alt: "Mangimi per cani Libra" },
    { src: dogTreats, alt: "Biscotti e snack colorati per cani" },
    { src: freshProduce, alt: "Prodotti freschi - cipolle e noci" },
    { src: petAccessories, alt: "Guinzagli e accessori per animali" },
  ];

  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + 3, images.length));
  };

  const handleShowLess = () => {
    setVisibleCount(3);
  };

  const visibleImages = images.slice(0, visibleCount);
  const showButton = images.length > 3;
  const isShowingAll = visibleCount >= images.length;

  return (
    <section className="py-12 section-alt">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6 animate-fade-in-up">
          <h2 className="mb-4 text-primary uppercase text-2xl md:text-4xl text-center" style={{ fontFamily: 'Verdana, sans-serif' }}>Il nostro negozio</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-4" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Un ambiente accogliente e ben fornito per ogni tua esigenza
          </p>
        </div>

        {/* Mobile and Tablet Grid - with show more/less functionality */}
        <div className="grid md:grid-cols-2 gap-6 lg:hidden">
          {visibleImages.map((image, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-2xl shadow-[var(--shadow-medium)] hover:shadow-[var(--shadow-hover)] transition-all duration-300 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>

        {/* Desktop Grid - shows all images */}
        <div className="hidden lg:grid lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-2xl shadow-[var(--shadow-medium)] hover:shadow-[var(--shadow-hover)] transition-all duration-300 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>

        {showButton && (
          <div className="text-center mt-8 lg:hidden">
            <button
              onClick={isShowingAll ? handleShowLess : handleShowMore}
              className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity duration-300"
            >
              {isShowingAll ? "Mostra di meno" : "Mostra più"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
